import Router from './router'
//Happy wedding HL
function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
